import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { EmployeeDetailPageContent } from "Components/Merchant/Employees/EmployeeDetailPageContent";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const EmployeeDetailPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Employee.Detail.Title)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("employees"),
      }}
    >
      <StyledPageWrapper>
        <PrimaryPaper>
          <EmployeeDetailPageContent />
        </PrimaryPaper>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default EmployeeDetailPage;
